export default __webpack_public_path__ + "static/media/corners.ae10e64a.md";